<h3>DE CIFRIS ATHESIS</h3>
<p>Il ciclo di seminari <i>De Cifris Athesis</i> presenta
	risultati di ricerca nell'ambito della <i>crittografia
		e applicazioni</i>.<br> I seminari saranno tenuti da
	<em>esperti nazionali e internazionali</em>, in lingua
	inglese e italiana, e saranno aperti a tutti.
</p>
<h5>Comitato organizzatore</h5>
<ul>
	<li> Silvio Ranise, Fondazione Bruno Kessler;</li>
	<li> Massimiliano Sala, Università di Trento;</li>
	<li> Roberto Zunino, Università di Trento;</li>
	<li>Irene Villa, Università di Trento; </li>
	<li>Christopher Spennato, Digital Innovation Hub Vicenza.</li>
</ul>
<hr id="recenti">
<h4><a (click)="toggleAttivita('recenti')">SEMINARI RECENTI</a></h4>
<div *ngIf="mostraFuturi==true">
	<p>POVO 1, Università di Trento, <b>Trento</b></p>
	<p class="warning">Avviso: causa dell'emergenza Coronavirus (Covid-19)
		organizzeremo i prossimi eventi in webinar.</p>
	<ul>
		<li>
			<b> 10 Maggio 2022 - 16:00</b>
			<ul>
				<li>
					<b>Marco Martinoli</b> -- Proton AG <br>
					<i>"Cryptography vs Real World"</i><br>
					<a href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/
								05.2022 Martinoli.pdf">Locandina</a> --
					<a href="../../../assets/attivita/seminariLocali/deCifris
								Athesis/Allegato1_Martinoli.pdf">Slide</a> --
					<a href="https://www.youtube.com/watch?v=3lYc-lkhRhY">Video</a>
				</li>
			</ul>
		</li>
		<li>
			<b> 12 Aprile 2022</b>
			<ul>
				<li>
					<b>Lorenzo Zaccagnini</b> -- Devoleum<br>
					<i>"Vulnerabilità note di Solidity"</i><br>
					<a href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/
								04.2022 Zaccagnini.pdf">Locandina</a> --
					<a href="../../../../assets/attivita/seminariLocali/deCifris
									Athesis/Allegato1_Athesis_Zaccagnini.pdf">Slide</a> --
					<a href="https://www.youtube.com/watch?v=4lnw7_uVhTA">Video</a>
				</li>
			</ul>
		</li>
	</ul>
</div>

<hr id="futuri">
<h4><a (click)="toggleAttivita('futuri')">PROSSIMI SEMINARI</a></h4>
<ul>
	<li>
		<b> 13 Dicembre 2022 - 15:00</b>
		<ul>
			<li>
				<b>Emanuele Giunta</b> -- IMDEA Software Institute, Universidad Politécnica de Madrid <br>
				<i>"On the Impossibility of Algebraic Vector Commitments in Pairing-Free Groups"</i><br>
				<a href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/12.2022 Giunta.pdf">Locandina</a>
			</li>
		</ul>
	</li>
</ul>

<hr id="passati">
<h4><a (click)="toggleAttivita('passati')">SEMINARI PASSATI</a></h4>
<div *ngIf="mostraPassati==true">
	<ul>

		<li>
			<b> 8 Febbraio 2022</b>
			<ul>
				<li>
					<b>Michele Orrù</b> -- UC Berkeley (US)<br>
					<i>"Breaking 20 years of Schnorr-like blind signatures"</i><br>
					<a href="../../../assets/attivita/seminariLocali/deCifris
								Athesis/OrruLocandina.pdf">Locandina</a> --
					<a href="../../../assets/attivita/seminariLocali/deCifris
								Athesis/orru-athesis.pdf">Slide</a>
				</li>
			</ul>
		</li>
		<li>
			<b> 12 Gennaio 2022</b>
			<ul>
				<li>
					<b>Giada Sciarretta</b> -- Fondazione Bruno Kessler, Trento<br>
					<i>"Applications based on CIE 3.0: from the design to the
						security assessment"</i><br>
					<a href=".././../../assets/attivita/seminariLocali/deCifris
								Athesis/SCIARRETTA.pdf">Locandina</a> --
					<a href="../../../assets/attivita/seminariLocali/deCifris
									Athesis/SciarrettaSlide.pdf">Slide</a> --
					<a href="https://mega.nz/file/qc1QwARa#DtfKxWqDj_6ka5KP8DJrzm
								cipx3by1IrWI80wHhjVKg">Video</a>
					<br>
				</li>
			</ul>
		</li>
		<li>
			<b>9 Novembre 2021 - 15:00</b>
			<ul>
				<li>
					<b>Valentina De Cian</b> -- TriNANDable‌ <br>
					<i>"LDPC‌ ‌codes‌ ‌for‌ ‌storage‌ ‌applications‌"</i><br>
					<a href="../../../../assets/attivita/seminariLocali/
								deCifrisAthesis/11.2021_DeCian.pdf">Locandina</a> --
					<a href="../../../../assets/attivita/seminariLocali/deCifris
									Athesis/DeCian-slide.pdf">Slide</a> --
					<a href="https://www.youtube.com/watch?v=RWlynaR4kWw">Video</a>
					<br>
				</li>
			</ul>
		</li>
		<li>
			<b>7 Giugno 2021 - 10:00</b>
			<ul>
				<li>
					<b>Marco Calderini</b> -- University of Bergen <br>
					<i>"Permutation groups and security of block ciphers"</i><br>
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/CalderiniLocandina.pdf">Locandina</a>
					--
					<a href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/calderiniSlide.pdf">Slide</a> --
					<a href="https://youtu.be/Zd2AqqA2UVM">Video</a>
					<br>
				</li>
			</ul>
		</li>
		<li>
			<b>20 Maggio 2021 - 10:00</b>
			<ul>
				<li>
					<b>Annamaria Iezzi</b> -- Université de la Polynésie Française <br>
					<i>"Strumenti per fare crittoanalisi nei grafi di isogenie supersingolari"</i><br>
					<a href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/Iezzi.pdf">Locandina</a> --
					<a href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/IezziIsogeny.pdf">Slide</a> --
					<a href="https://youtu.be/b9YU-UNgVSs">Video</a>
					<br>
				</li>
			</ul>
		</li>
		<li>
			<b>26 Aprile 2021 - 12:00</b>
			<ul>
				<li>
					<b>Riccardo Longo</b> -- Università degli Studi di Trento <br>
					<i>"Ledger Pubblico per Dati Sensibili"</i><br>
					<a href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/Longo.pdf">Locandina</a> --
					<a href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/LongoDCA.pdf">Slide</a> --
					<a href="https://youtu.be/649l2aKU1jY">Video</a>
					<br>
				</li>
			</ul>
		</li>
		<li>
			<b>25 Marzo 2021</b>
			<ul>
				<li>
					<b>Irene Villa</b> -- Università di Trento <br>
					<i>"Analysis, classification and construction of APN Boolean functions"</i><br>
					<a href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/ireneVilla.pdf">Locandina</a> --
					<a href="../../../../assets/attivita/seminariLocali/deCifrisAthesis/ireneVillaSlide.pdf">Slide</a>
					--
					<a href="https://youtu.be/f-dG7rru0NU ">Video</a>
					<br>
				</li>
			</ul>
		</li>
		<li>
			<b>25 Gennaio 2021</b>
			<ul>
				<li>
					<b>Daniele Venturi</b> --
					<a href="https://www.uniroma1.it/">Università di Roma - La Sapienza</a>
					<br>
					<i>"Immunizing Cryptographic Primitives against Complete Subversion"</i>
					<br>
					<a href="../../../../assets/attivita/seminariLocali/deCifris
								Athesis/01.2021-VENTURI.pdf">Locandina</a> --
					<a href="../../../../assets/attivita/seminariLocali/deCifris
								Athesis/locandina_Venturi.pdf"> Slide</a> --
					<a href="https://youtu.be/uXD3v1F1RDw">Video</a>
				</li>
			</ul>
		</li>
		<li><b>3 Dicembre 2020</b>
			<ul>
				<li>
					<b>Luca Lusini</b> --
					<a href="https://www.agid.gov.it/">AGID</a>
					<br>
					<i>"Studiare la crittografia dei ransomware"</i>
					<br>
					<a href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/3.12.2020-Lusini.pdf">
						Locandina</a> --
					<a href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/slide_Lusini.pdf">
						Slide</a> --
					<a href="https://youtu.be/cVV0O-VUwus">Video</a>
				</li>
			</ul>
		</li>
		<li><b>18 novembre 2020</b>
			<ul>
				<li>
					<b>Darren Tapp</b> --
					<a href="https://www.dash.org/it/">DASH</a>
					<br>
					<i>"Consensus among computer networks"</i>
					<br>
					<a href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/18.11.2020_TAPP.pdf">
						Locandina </a> --
					<a href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/Darren_Tapp.pdf">Slide</a>
					--
					<a href="https://www.youtube.com/watch?v=rzHJ0wsqXcg">Video</a>
				</li>
			</ul>
		</li>
		<li><b>18 giugno 2020</b>
			<ul>
				<li>
					<b>Federico Mazzone</b> -- Università di Trento
					<br><i>"Paillier homomorphic encryption and its application to build a share conversion
						protocol"</i><br>
					<a
						href='../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/locandina_MAZZONE.pdf'>Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/slide_Mazzone.pdf">Slide</a>
					--
					<a href="https://youtu.be/bOOesu7O1f8">Video</a>.
				</li>
			</ul>
		</li>
		<li><b>29 maggio 2020</b>
			<ul>
				<li>
					<b>Chiara Spadafora</b> -- Università di Trento<br>
					<i>"A new blockchain-based secure e-voting protocol"</i><br>
					<a
						href='../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/SPADAFORA-locandina.pdf'>Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/slides_spadafora.pdf">Slide</a>
					--
					<a href="https://youtu.be/Lpn_u1ziLmQ">Video</a>.
				</li>
			</ul>
		</li>
		<li><b>23 gennaio 2020</b>
			<ul>
				<li>
					<b>Mariano Ceccato </b> -- Università di Verona<br>
					<i>"A Federated Society of Bots for Smart Contract Testing"</i><br>
					<a
						href='../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/CECCATO_23.01.2020'>Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/ceccato-slide.pdf">Slide</a>.
				</li>
				<li>
					<b>Alessandro Tomasi</b> -- Fondazione Bruno Kessler<br>
					<i>"Digital identity - modern tools and perspectives"</i><br>
					<a
						href='../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/Tomasi_23.01.2020.pdf'>Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/TOMASI-slide.pdf">Slide</a>.
				</li>
			</ul>
		</li>
		<li><b>16 dicembre 2019</b>
			<ul>
				<li>
					<b> Luca Mariot</b> -- Università di Milano Bicocca<br>
					<i>"Search for optimal Boolean functions"</i><br>
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/mariot-locandina.pdf">Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/mariot-slide.pdf">Slide</a>.
				</li>
			</ul>
		</li>
		<li><b>27 novembre 2019</b>
			<ul>
				<li>
					<b>Giovanni Schmid</b> -- CNR - ICAR<br>
					<i>"Hyperledger Fabric: crittografia per blockchain permissioned"</i><br>
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/schmid-locandina.pdf">Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/schmid-slide.pdf">Slide</a>.
				</li>
				<li>
					<b> Matteo Bonini</b> -- POLIMI<br>
					<i>"Analisi sulla De-anonimizzazione di blockchain"</i><br>
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/bonini-locandina.pdf">Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/bonini-slide.pdf">Slide</a>.
				</li>
			</ul>
		</li>
		<li><b>30 ottobre 2019</b>
			<ul>
				<li>
					<b> Michele Elia</b> -- Politecnico di Torino<br>
					<i>"Continued Fractions and Factoring"</i><br>
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/michele2elia-locandina.pdf">Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/michele2elia-slide.pdf">Slide</a>.
				</li>
				<li>
					<b> Maurizio Murgia</b> -- Università di Trento<br>
					<i>"An introduction to Libra and LibraBFT consensus algorithm"</i><br>
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/murgia-locandina.pdf">Locandina</a>
					--
					<a href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/murgia-slide.pdf">
						Slide</a>.
				</li>
				<li>
					<b>Giovanni Antino</b> -- AiliA SA - Takamaka.io<br>
					<i>"Non-interactive time-based proof of stake"</i><br>
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/antino-locandina.pdf">Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/antino-slide.pdf">Slide</a>.
				</li>
			</ul>
		</li>
		<li><b>10 settembre 2019</b>
			<ul>
				<li>
					<p><b>Ivan Visconti</b> -- Università di Salerno<br>
						<i>"The Rush Dilemma: Smart Contracts on Forking Blockchains"</i><br>
						<a
							href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/ivanvisconti-locandina.pdf">Locandina</a>
						--
						<a
							href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/ivanvisconti-slide.pdf">Slide</a>.
					</p>
				</li>
				<li>
					<p><b>Chiara Bodei</b> -- Università di Pisa<br>
						<i>"Control Flow Analysis for process algebras with applications to security"</i><br>
						<a
							href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/bodei-locandina.pdf">Locandina</a>
						--
						<a
							href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/bodei-slide.pdf">Slide</a>.
					</p>
				</li>
				<li>
					<b>Carlo Blundo</b> -- Università di Salerno"<br>
					<i>"Privacy-preserving Information Sharing"</i><br>
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/blundo-locandina.pdf">Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/blundo-slide.pdf">Slide</a>.
				</li>
			</ul>
		</li>
		<li><b>11 giugno 2019</b>
			<ul>
				<li>
					<b>Calderini Marco</b> -- University of Bergen<br>
					<i>"On equivalence relations of Boolean functions"</i><br>
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/calderini-locandina.pdf">Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/calderini-slide.pdf">Slide</a>.
				</li>
			</ul>
		</li>
		<li><b>15 aprile 2019</b>
			<ul>
				<li>
					<b>Ottavio G. Rizzo</b> -- Università di Milano<br>
					<i>"Moltiplicare efficientemente polinomi in caratteristica 2"</i><br>
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/rizzo-locandina.pdf">Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/rizzo-slide.pdf">Slide</a>.
				</li>
			</ul>
		</li>
		<li><b>7 marzo 2019</b>
			<ul>
				<li>
					<b>Claudio Orlandi</b> -- Aarhus University<br>
					<i>"Quisquis: A New Design for Anonymous Cryptocurrencies"</i><br>
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/orlandi-locandina.pdf">Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/orlandi-slide.gz">Slide</a>.
				</li>
				<li>
					<b>Michele Elia</b> -- Politecnico di Torino<br>
					<i>"On a Problem of Perron"</i><br>
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/elia-locandina.pdf">Locandina</a>
					--
					<a href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/elia-slide.pdf">Slide</a>.
				</li>
			</ul>
		</li>
		<li><b>11 febbraio 2019</b>
			<ul>
				<li>
					<b>Federico Pintore</b> -- University of Oxford<br>
					<i>"Cryptographic primitives from elliptic curve isogenies"</i><br>
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/DeCifrisAthesis_Pintore2019.pdf">Locandina</a>
					--
					<a
						href="../../../../../../assets/attivita/seminariLocali/deCifrisAthesis/pintore-slide.pdf">Slide</a>.
				</li>
			</ul>
		</li>
	</ul>
</div>